import React, { Component } from "react";
import DataRadio from "../DataRadio";
import { getDictItemList } from "../../service/dict";

import "./index.less";

export default class DictRadio extends Component {

  onLoad = () => {
    const { dict: dictCode, } = this.props;
    return getDictItemList({ dictCode, }).then(data => {
      const options = this.getOptions(data);
      return options;
    });
  };

  getOptions = (data) => {
    let options = [...data];
    options = options.map(item => ({
      label: item.label,
      value: this.parse(item.value),
    }));
    return options;
  };

  parse = (value) => {
    const { parse } = this.props;
    if (typeof parse === "string") {
      return {
        "number": Number,
        "string": String,
      }[parse](value);
    }
    return parse(value);
  };

  render() {
    return (
      <DataRadio
        {...this.props}
        onLoad={this.onLoad}
      />
    );
  };
};
